module.exports = __webpack_public_path__ + "static/image/history/pc/201506_2.ver2_0_2.jpg?79576858";